import { useEffect } from "react";

export default function LaunchReady() {
  useEffect(() => {
    document.documentElement.classList.add("app-ready");
  }, []);
  return null;
}
